// extracted by mini-css-extract-plugin
export default {"root":"PlasmicInProgressSign_root__+feMW","text":"PlasmicInProgressSign_text__Ytojr"};